import Spinner from "./spinner";

const ButtonWhite = (props: any) => {
  let textButton = props.textButton ?? "";
  let spinner = props.spinner ?? false;
  let className = props.className + " btn btnWhite  m-0 ";

  let type = props.type ?? "button";

  return (
    <button
      type={type}
      disabled={spinner}
      onClick={props.handleChange}
      className={className}
    >
      {textButton}
      {spinner && <Spinner />}
    </button>
  );
};

export default ButtonWhite;
